import React from "react";
import { Tooltip } from "antd";
import { TEXT } from "../../EmployeeSkillsBridgerV2.constants";
import { ProficiencyInputStyled, INVALID_TOOLTIP_STYLE } from "./SelfReportedProficiencyCell.styles";

const SelfReportedProficiencyCell = React.memo(({
  skillId,
  profileProficiency,
  value,
  isInvalid,
  onValueChange,
}) => (
  <Tooltip
    title={isInvalid ? TEXT.INVALID_PROFICIENCY_MSG : null}
    open={isInvalid || undefined}
    color="orange"
    {...INVALID_TOOLTIP_STYLE}
  >
    <ProficiencyInputStyled
      precision={0}
      value={value}
      status={isInvalid ? "warning" : ""}
      onChange={(val) => onValueChange(skillId, val, profileProficiency)}
    />
  </Tooltip>
));

export default SelfReportedProficiencyCell;
